module.exports = require("./dist/bis-date-picker.esm.js");
